/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PosOnlineStoreApiModel {
  /**
   * Online store active flag
   */
  active?: number;
  /**
   * Users cart expire period in days
   */
  cart_expire_days?: number;
  /**
   * Order type used in schema
   */
  order_type?: PosOnlineStoreApiModelOrderTypeEnum;
  /**
   * Payment in store
   */
  payment_type?: PosOnlineStoreApiModelPaymentTypeEnum;
  /**
   * Terminal ID
   */
  terminal_id?: string;
  /**
   * Transaction type used in schema
   */
  transaction_type?: PosOnlineStoreApiModelTransactionTypeEnum;
}
export enum PosOnlineStoreApiModelOrderTypeEnum {
  OnlineStore = 'online-store',
  FuelTaxi = 'fuel-taxi'
}
export enum PosOnlineStoreApiModelPaymentTypeEnum {
  None = 'none',
  Bonuses = 'bonuses',
  Possible = 'possible',
  Required = 'required'
}
export enum PosOnlineStoreApiModelTransactionTypeEnum {
  Sale = 'sale',
  Reserve = 'reserve',
  AuthorizePayment = 'authorize-payment'
}
